import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  Select,
} from "@chakra-ui/core";
import React from "react";

function DynoInput({
  optionsArr,
  label,
  inputType,
  selectPH,
  inputPH,
  selectVal,
  inputVal,
}) {
  return (
    <FormControl minWidth="130px" marginX="0.5em">
      <FormLabel>{label}</FormLabel>
      <InputGroup>
        <Select roundedRight="0" placeholder={selectPH}>
          {optionsArr.map((opt) => (
            <option value={opt.value} key={opt.label}>
              {opt.label}
            </option>
          ))}
        </Select>
        <Input
          maxWidth="90px"
          type={inputType}
          placeholder={inputPH}
          roundedLeft="0"
        />
      </InputGroup>
    </FormControl>
  );
}

export default DynoInput;
